import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a8082d6f7c49b4d63f4575384c4e52e94b from "./generated-024dc499-55d1-48cd-9a47-f48877cc42d0.json";

import abf83ca191c7015d0e2a4568ca71d3aceb from "./generated-959fb5f3-0995-422c-9b4d-70b3f0f9744d.json";

import acdc31b18f50434960fa0bf054d2fe223b from "./generated-fc3e74fb-8344-413e-a160-080f378255c4.json";

import a6017ebfed9402a323a931bc4a8061ae1b from "./generated-bd5a8156-70b3-4a51-a4e1-0888dcafdff1.json";

import a0b40a40f4bae9125941111ab7cbe8fdfb from "./generated-ae7e6948-1e6a-4e43-a31f-04b017d2120c.json";

import ab08ff6812f8a3a3346eebc437900c354b from "./generated-84b3adcb-aae8-4e90-974a-5403f5840f13.json";

import ac37c1b40ff6975ab992d24cee13de8e5b from "./generated-7beb3013-37f5-4f43-8f9d-27491b4d3265.json";

import ad260ff77a14fa6ec5896341e236daa7fb from "./generated-06b4be82-f8f9-494f-8c6f-82b243c7cb4a.json";

import a4caaf92f310db9f1e8c763603bdbb92db from "./generated-ab3aebc5-b851-45cd-948d-ff04cb5c337e.json";

import a824f7519465090b85a479a3fde17ded5b from "./generated-abed8bd8-75a1-4696-8291-094d51e60056.json";

import a9c40874f845c7760ec31e5003c9e26beb from "./generated-38ffa984-3d45-4ff3-a104-fa1c46ee26c8.json";

import abd82008b01eafaa1bade5f08f5ef55b3b from "./generated-10d828cf-d0d8-45f3-9e04-b18590b40b0f.json";

import a35f94f74083ad7ac6146416edab0462cb from "./generated-c5bea7dc-a902-48cd-a647-cecb15740e78.json";

import ad4c2f2d732f4b0f390b652145a34a59ab from "./generated-942b270c-d0da-4bd4-9589-c94d6a4d642a.json";

import a6cacfbc4028450f93937e4b31b8b70c5b from "./generated-215b519c-915b-43fe-a581-632a653fb894.json";

import aaddd309d9ab011ee2d6e7d8bfd3fbab8b from "./generated-dfa26ded-06de-44b2-9079-ec6cdc8844b7.json";

import aeb1b0ca614653e9951cabdee0437060ab from "./generated-3371e85b-884c-4a4b-b338-2170e40106a3.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a8082d6f7c49b4d63f4575384c4e52e94b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abf83ca191c7015d0e2a4568ca71d3aceb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(acdc31b18f50434960fa0bf054d2fe223b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a6017ebfed9402a323a931bc4a8061ae1b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0b40a40f4bae9125941111ab7cbe8fdfb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ab08ff6812f8a3a3346eebc437900c354b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac37c1b40ff6975ab992d24cee13de8e5b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ad260ff77a14fa6ec5896341e236daa7fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a4caaf92f310db9f1e8c763603bdbb92db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a824f7519465090b85a479a3fde17ded5b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a9c40874f845c7760ec31e5003c9e26beb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(abd82008b01eafaa1bade5f08f5ef55b3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a4caaf92f310db9f1e8c763603bdbb92db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a35f94f74083ad7ac6146416edab0462cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad4c2f2d732f4b0f390b652145a34a59ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a4caaf92f310db9f1e8c763603bdbb92db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a6cacfbc4028450f93937e4b31b8b70c5b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aaddd309d9ab011ee2d6e7d8bfd3fbab8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aeb1b0ca614653e9951cabdee0437060ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a6cacfbc4028450f93937e4b31b8b70c5b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */